import styled from 'styled-components';
import { theme } from '../../../../styles/theme';
import { AuthFormLink } from '../LoginPagesUI';

const Container = styled.div`
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
  color: ${theme.colors.secondary800};
`;
const StyledAuthFormLink = styled(AuthFormLink)`
  font-size: inherit;
`;

const TosMessage = () => {
  return (
    <Container>
      By clicking &quot;Login&quot;, you agree to the Kubit&apos;s Terms of
      Service and{' '}
      <StyledAuthFormLink
        as="a"
        href="https://kubit.ai/privacy-policy/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Privacy Policy
      </StyledAuthFormLink>
      .
    </Container>
  );
};
export default TosMessage;
